import type { Prompt, User, Purchase } from "./types";

export const mockPrompts: Prompt[] = [
  {
    id: "1",
    title: "ChatGPT 블로그 글쓰기 마스터 프롬프트",
    description:
      "매력적이고 SEO 최적화된 블로그 글을 작성하는 완벽한 프롬프트입니다. 독자의 관심을 끄는 헤드라인부터 검색 엔진 최적화까지 모든 것을 포함합니다.",
    category: "콘텐츠 제작",
    price: 9900,
    author: {
      name: "김민지",
      avatar: "/diverse-user-avatars.png",
    },
    thumbnail: "/blog-writing-desk.png",
    images: [
      "/blog-writing-desk.png",
      "/blog-writing-screen.jpg",
      "/content-creation-workspace.png",
    ],
    prompt_text:
      "당신은 전문 블로그 작가입니다. 다음 주제에 대해 SEO 최적화된 블로그 글을 작성하세요:\n\n주제: [주제를 입력하세요]\n키워드: [주요 키워드]\n\n다음 구조를 따라주세요:\n1. 독자의 관심을 끄는 도입부\n2. 문제 정의 및 해결책 제시\n3. 구체적인 예시와 데이터\n4. 실행 가능한 팁\n5. 명확한 결론과 CTA",
    tags: ["블로그", "SEO", "콘텐츠"],
    rating: 4.8,
    reviewCount: 127,
    createdAt: "2024-01-15",
  },
  {
    id: "2",
    title: "미드저니 사실적인 인물 사진 프롬프트",
    description:
      "초현실적인 인물 사진을 생성하는 미드저니 전문 프롬프트 템플릿입니다.",
    category: "이미지 생성",
    price: 14900,
    author: {
      name: "박준호",
      avatar: "/diverse-user-avatars.png",
    },
    thumbnail: "/portrait-photography.png",
    images: [
      "/portrait-photography.png",
      "/realistic-portrait-photography.jpg",
      "/professional-headshot.png",
    ],
    prompt_text:
      "portrait photo of [subject description], professional lighting, 85mm lens, f/1.4, shallow depth of field, natural skin tones, soft shadows, cinematic color grading, high detail, photorealistic, shot on Canon EOS R5 --ar 3:4 --style raw --v 6",
    tags: ["미드저니", "사진", "인물"],
    rating: 4.9,
    reviewCount: 89,
    createdAt: "2024-01-20",
  },
  {
    id: "3",
    title: "코딩 면접 준비 완벽 가이드 프롬프트",
    description:
      "알고리즘 문제부터 시스템 디자인까지 코딩 면접을 완벽하게 준비하세요.",
    category: "개발",
    price: 19900,
    author: {
      name: "이서연",
      avatar: "/diverse-user-avatars.png",
    },
    thumbnail: "/new coding-interview-scenario.png",
    images: [
      "/new coding-interview-scenario.png",
      "/coding-interview-preparation.jpg",
      "/algorithm-study.jpg",
    ],
    prompt_text:
      "당신은 실리콘밸리 선임 개발자이자 면접관입니다. 다음 주제로 코딩 면접 문제를 출제하고 상세한 해설을 제공하세요:\n\n주제: [알고리즘/자료구조/시스템 디자인]\n난이도: [쉬움/중간/어려움]\n\n1. 문제 설명\n2. 입출력 예시\n3. 제약 조건\n4. 힌트\n5. 최적 솔루션 (시간/공간 복잡도 포함)\n6. 대안적 접근법\n7. 면접관이 물어볼 추가 질문",
    tags: ["코딩", "면접", "알고리즘"],
    rating: 4.7,
    reviewCount: 203,
    createdAt: "2024-01-18",
  },
  {
    id: "4",
    title: "마케팅 카피라이팅 프롬프트 번들",
    description:
      "전환율을 높이는 마케팅 카피를 작성하는 30가지 프롬프트 모음입니다.",
    category: "마케팅",
    price: 24900,
    author: {
      name: "최유진",
      avatar: "/diverse-user-avatars.png",
    },
    thumbnail: "/marketing-copywriting.jpg",
    images: [
      "/marketing-copywriting.jpg",
      "/advertising-campaign.jpg",
      "/conversion-optimization.png",
    ],
    prompt_text:
      "당신은 10년 경력의 카피라이터입니다. 다음 제품/서비스에 대한 매력적인 마케팅 카피를 작성하세요:\n\n제품/서비스: [제품명]\n타겟 고객: [고객 페르소나]\n핵심 메시지: [주요 가치 제안]\n\nAIDA 모델을 활용하여:\n1. Attention (주목): 눈길을 끄는 헤드라인\n2. Interest (관심): 고객 문제와 공감\n3. Desire (욕구): 제품의 혜택과 차별점\n4. Action (행동): 명확한 CTA",
    tags: ["마케팅", "카피라이팅", "광고"],
    rating: 4.6,
    reviewCount: 156,
    createdAt: "2024-01-10",
  },
  {
    id: "5",
    title: "Stable Diffusion 판타지 아트 프롬프트",
    description:
      "환상적인 판타지 세계를 창조하는 Stable Diffusion 프롬프트입니다.",
    category: "이미지 생성",
    price: 12900,
    author: {
      name: "강동혁",
      avatar: "/diverse-user-avatars.png",
    },
    thumbnail: "/enchanted-forest-guardian.png",
    images: [
      "/enchanted-forest-guardian.png",
      "/enchanted-valley.png",
      "/magical-creature-concept.jpg",
    ],
    prompt_text:
      "a majestic [fantasy subject], ethereal atmosphere, magical glowing particles, intricate details, epic fantasy art, by Greg Rutkowski and Alphonse Mucha, volumetric lighting, mystical colors, cinematic composition, trending on artstation, highly detailed, 8k resolution, masterpiece",
    tags: ["Stable Diffusion", "판타지", "아트"],
    rating: 4.5,
    reviewCount: 94,
    createdAt: "2024-01-22",
  },
  {
    id: "6",
    title: "소셜미디어 콘텐츠 기획 프롬프트",
    description:
      "인스타그램, 틱톡, 유튜브 콘텐츠를 한 번에 기획하는 프롬프트입니다.",
    category: "콘텐츠 제작",
    price: 16900,
    author: {
      name: "윤지아",
      avatar: "/diverse-user-avatars.png",
    },
    thumbnail: "/social-media-content-planning.jpg",
    images: [
      "/social-media-content-planning.jpg",
      "/instagram-posts-grid.jpg",
      "/youtube-thumbnail-ideas.jpg",
    ],
    prompt_text:
      "당신은 SNS 마케팅 전문가입니다. 다음 브랜드의 한 달 소셜미디어 콘텐츠 캘린더를 작성하세요:\n\n브랜드: [브랜드명]\n업종: [업종]\n타겟: [타겟 오디언스]\n\n각 플랫폼별로:\n📸 인스타그램: 15개 포스트 아이디어 (피드, 릴스, 스토리)\n🎵 틱톡: 10개 숏폼 영상 아이디어\n📹 유튜브: 4개 롱폼 콘텐츠 기획\n\n각 아이디어에는 제목, 후킹 포인트, 해시태그, CTA 포함",
    tags: ["소셜미디어", "SNS", "콘텐츠"],
    rating: 4.7,
    reviewCount: 112,
    createdAt: "2024-01-12",
  },
];

export const categories = [
  "전체",
  "콘텐츠 제작",
  "이미지 생성",
  "개발",
  "마케팅",
  "비즈니스",
  "교육",
];

// Mock user (로그인 상태 시뮬레이션)
export const mockUser: User = {
  id: "user1",
  email: "user@example.com",
  nickname: "프롬프트러버",
  avatar: "/diverse-user-avatars.png",
};

// Mock purchases (구매한 프롬프트 시뮬레이션)
export const mockPurchases: Purchase[] = [
  {
    id: "purchase1",
    promptId: "1",
    prompt: mockPrompts[0],
    purchaseDate: "2024-01-25",
  },
];
